// extracted by mini-css-extract-plugin
export default {"label":"Label_label__Zz0X1","inline":"Label_inline__cAhVu"};